import React from "react";
import { SiShopify, SiReact, SiNodedotjs } from "react-icons/si";
import { HiOutlineSparkles } from "react-icons/hi2";

const SERVICES = [
  {
    num: "01",
    icon: <SiShopify />,
    title: "Shopify Development",
    desc: "Custom Liquid themes, Plus-grade storefronts, headless React fronts and Shopify apps. Built for speed, conversion and editor happiness.",
    tags: ["Liquid", "Shopify Plus", "Hydrogen", "App Dev"],
  },
  {
    num: "02",
    icon: <SiReact />,
    title: "Web Applications",
    desc: "Production-grade React, Next.js and React Native apps with strong UX, accessibility and componentized design systems.",
    tags: ["React", "Next.js", "TypeScript", "Design Systems"],
  },
  {
    num: "03",
    icon: <SiNodedotjs />,
    title: "API & Backend",
    desc: "Node.js, Express, Laravel and PHP backends with MongoDB, MySQL and Elasticsearch. Clean APIs, sane data models, fast queries.",
    tags: ["Node.js", "Laravel", "MongoDB", "Elasticsearch"],
  },
  {
    num: "04",
    icon: <HiOutlineSparkles />,
    title: "Performance & SEO",
    desc: "Core Web Vitals tuning, structured data, schema markup and technical SEO. From 60s loads to sub-second TTFB and clean Lighthouse runs.",
    tags: ["Web Vitals", "Schema", "Lighthouse", "Caching"],
  },
];

function handleMouseMove(e) {
  const r = e.currentTarget.getBoundingClientRect();
  e.currentTarget.style.setProperty("--mx", `${e.clientX - r.left}px`);
  e.currentTarget.style.setProperty("--my", `${e.clientY - r.top}px`);
}

export default function Services() {
  return (
    <section className="section" id="services">
      <div className="container-x">
        <div className="section-head reveal">
          <div className="section-head__title">
            <span className="eyebrow">What I do</span>
            <h2>
              Services
              <br />
              <span className="it text-accent">crafted with care.</span>
            </h2>
          </div>
          <div className="section-head__aside">
            <p>
              Four core practices, one obsession: shipping work that performs
              in production — not just looks nice in a Figma frame.
            </p>
          </div>
        </div>

        <div className="grid grid-2">
          {SERVICES.map((s) => (
            <article
              key={s.num}
              className="service reveal"
              onMouseMove={handleMouseMove}
            >
              <div className="service__icon">{s.icon}</div>
              <span className="service__num">— {s.num}</span>
              <h3 className="service__title">{s.title}</h3>
              <p className="service__desc">{s.desc}</p>
              <div className="service__tags">
                {s.tags.map((t) => (
                  <span key={t}>{t}</span>
                ))}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
